export default __webpack_public_path__ + "static/selfapp-watch-mobile-15c9aa9709833a90d18d78adda24d00d.jpg";